import React from 'react';
import { message } from 'antd';
import Modal from '../../../Modal';
import {
  AntdColumn,
  AntdColumnUtilType,
  AntdTableOption,
  Option,
  SearchOption,
  TableListData,
} from '../../../../types/common/table';
import { useTableList } from '../../../../hooks/common/useTableList';
import { useSelectList } from '../../../../hooks/common/useSelectList';
import Table from '../../../_table/Table/Table';
import Button from '../../../Button';
import { SelectListModalStyle } from './style';
import { changeAntdSortToTableSort, changeTableSortToAntdSort } from '../../../../lib/utils/tableUtils';

interface SelectListModalProps<T, F> {
  queryKey: string[];
  fetcher: (option: SearchOption<F>) => Promise<TableListData<T>>;
  value?: T[];
  initialOption?: Option<F>;
  columns: (utils: AntdColumnUtilType<T, F>) => AntdColumn<T>[];
  onOk: (selectedList: T[]) => void;
  onClose: () => void;
}

const SelectListModal = <T extends { id: number }, F extends Record<string, unknown>>(
  props: SelectListModalProps<T, F>,
) => {
  const { queryKey, fetcher, columns, value = [], onOk, onClose, initialOption } = props;
  const { totalCount, list, pagination, filterOption, sortOption, refetchList, resetOption } = useTableList({
    fetcher,
    initialOption,
    queryKey,
  });
  const { selectedList, changeSelectList } = useSelectList({
    list,
    canMultiple: true,
    value,
  });

  const checkedIdList = selectedList.map((item) => item.id);
  const currentIdList = value.map((item) => item.id);
  const handleOk = () => {
    if (!selectedList.length) {
      message.error('아이템을 선택해주세요');
      return;
    }
    onOk(selectedList);
  };

  return (
    <Modal
      title="아이템 리스트"
      isOpen={true}
      width={1200}
      height={687}
      isFooter={true}
      onOk={handleOk}
      onClose={onClose}
    >
      <SelectListModalStyle>
        <div className="summary">
          <span className="total-cnt">
            <span className="cnt">{totalCount}</span>건이 조회되었습니다.
          </span>

          <div className="button-group">
            <Button isRadius color="primary" text="필터 초기화" onClick={resetOption} />
          </div>
        </div>
        <Table
          rowKey={(record: T) => record.id}
          columns={(utils: any) => columns({ ...utils })}
          emptyText="리스트가 없습니다"
          list={list.map((item) => ({ ...item, uncheckable: currentIdList.includes(item.id) }))}
          size="middle"
          bordered={true}
          scroll={{ x: true }}
          onCheck={changeSelectList}
          selectedList={checkedIdList}
          getList={(option: AntdTableOption<F>): void =>
            refetchList({
              ...option,
              sortOption: option.sortOption && changeAntdSortToTableSort(option.sortOption),
            })
          }
          filterOption={filterOption}
          sortOption={changeTableSortToAntdSort(sortOption)}
          pagination={{
            ...pagination,
            totalCnt: totalCount,
          }}
        />
      </SelectListModalStyle>
    </Modal>
  );
};

export default SelectListModal;
